/* @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import LegacyButton from '@atlaskit/button/standard-button';
import { IconButton } from '@atlaskit/button/new';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import RetryIcon from '@atlaskit/icon/glyph/retry';
import messages from './messages';
export const RetryIconButton = ({
  onClick,
  tabIndex
}) => {
  const {
    formatMessage
  } = useIntl();
  const tooltip = formatMessage(messages.retryPrompt);
  return jsx(Tooltip, {
    content: tooltip,
    position: "top"
  }, getBooleanFF('platform.design-system-team.editor-new-button_jjjdo') ? jsx(IconButton, {
    testId: "retry-prompt-button",
    type: "button",
    onClick: onClick,
    icon: RetryIcon,
    label: tooltip,
    appearance: "default",
    tabIndex: tabIndex
  }) : jsx(LegacyButton, {
    "aria-label": tooltip,
    testId: "retry-prompt-button",
    type: "button",
    onClick: onClick,
    iconBefore: jsx(RetryIcon, {
      label: tooltip
    }),
    appearance: "default",
    tabIndex: tabIndex
  }));
};